// extracted by mini-css-extract-plugin
export var chevron = "_mr-4";
export var chevronExpanded = "_mr-5";
export var row = "_mr-0";
export var rowBody = "_mr-6";
export var rowDescription = "_mr-7";
export var rowHeader = "_mr-1";
export var rowTitle = "_mr-2";
export var rowTitleComplete = "_mr-3";